"use client";

import { t } from "@/lib/localization";
import { SpacerBlock as SpacerBlockType } from "@/lib/utils/lomdaV3/types";
import { useBlockEditable } from "../../../hooks/useBlockEditable";
import { clampSpacerHeight } from "../../../lib/blockRegistry";

const LABEL_MIN_HEIGHT = 24;

export default function SpacerBlock({ block }: { block: SpacerBlockType }) {
    const editable = useBlockEditable();
    const height = clampSpacerHeight(block.data.height);

    if (!editable) return <div aria-hidden style={{ height }} />;

    return (
        <div
            style={{ height }}
            className="lomda-v3-chrome flex items-center justify-center overflow-hidden rounded-[10px] border border-dashed border-[hsl(var(--lomda-border-dashed))] text-xs text-[hsl(var(--lomda-muted-text))]"
        >
            {height >= LABEL_MIN_HEIGHT && (
                <span dir="ltr">
                    {t("lomda-v3-editor.spacer.px", undefined, {
                        value: height,
                    })}
                </span>
            )}
        </div>
    );
}
